import React, { useCallback, useRef, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { HashRouter } from "react-router-dom";
import { Security } from '@okta/okta-react';
import { oktaAuth } from './pages/Login';
import { useNavigate } from 'react-router-dom';
import AuthTokenSync from './components/AuthTokenSync';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community';
import { SatelliteProvider } from './context/SatelliteContext';

ModuleRegistry.registerModules([AllCommunityModule]);

// Wrapper component to provide navigate function for Security
function AppWithSecurity() {
  const navigate = useNavigate();
  const navigateRef = useRef(navigate);
  useEffect(() => {
    navigateRef.current = navigate;
  }, [navigate]);

  const restoreOriginalUri = useCallback(async (_oktaAuth, originalUri) => {
    let path = '/dashboard';
    if (originalUri) {
      if (originalUri.startsWith('http://') || originalUri.startsWith('https://')) {
        try {
          const u = new URL(originalUri);
          if (u.searchParams.has('code') || u.searchParams.has('state')) {
            path = '/dashboard';
          } else {
            path = u.hash ? u.hash.replace(/^#/, '') : u.pathname || '/dashboard';
            if (!path || path === '/') path = '/dashboard';
          }
        } catch {
          path = '/dashboard';
        }
      } else {
        path = originalUri.startsWith('/') ? originalUri : '/' + originalUri;
        if (!path || path === '/') path = '/dashboard';
      }
    }
    navigateRef.current(path, { replace: true });
  }, []);

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      <AuthTokenSync />
      <App />
    </Security>
  );
}

// Creating the root application component
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <HashRouter>
    <SatelliteProvider>
      <AppWithSecurity />
    </SatelliteProvider>
  </HashRouter>
);